import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LimitStringPipe } from './pipes/limit-string.pipe';
import { GeneralModalComponent } from './modals/general-modal/general-modal.component';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { DurationPipe } from './pipes/duration.pipe';
import { CustomAlertComponent } from './modals/custom-alert/custom-alert.component';
import { MatIconModule } from '@angular/material/icon';
import { NChoicesModalComponent } from './modals/nchoices-modal/nchoices-modal.component';



@NgModule({
  declarations: [LimitStringPipe, GeneralModalComponent, TimeFormatPipe, DurationPipe, CustomAlertComponent, NChoicesModalComponent],
  imports: [
    CommonModule,
    MatIconModule
  ],
  exports: [
    LimitStringPipe,
    TimeFormatPipe,
    DurationPipe
  ]
})
export class SharedModule { }
